import {
	Component, Input, Output, EventEmitter, ChangeDetectorRef
} from '@angular/core';
import { InfoSetView } from 'UvExplorerServer.Dtos.TS/Session';

@Component({
	selector: 'ip-mac-finder-result-dialog',
	templateUrl: './ipmacfinder-result-dialog.component.html',
})
export class IpMacFinderResultDialogComponent {

	@Input()
	public visible: boolean;

	@Input()
	public sightings: InfoSetView;

	@Output()
	public visibleChange: EventEmitter<boolean>;

	@Output()
	public onOk: EventEmitter<any>;

	constructor(private changeDetector: ChangeDetectorRef) {
		this.visible = false;
		this.visibleChange = new EventEmitter<boolean>();
		this.onOk = new EventEmitter<any>();
	}

	public show(): void {
		this.visible = true;
		this.visibleChange.emit(true);
		this.changeDetector.markForCheck();
	}

	public hide(): void {
		this.visible = false;
		this.visibleChange.emit(false);
		this.changeDetector.markForCheck();
	}

	public onDialogHide(): void {
		this.hide();
	}

	public onOkClicked(): void {
		this.hide();
		this.onOk.emit();
	}
}
